import React from "react";
import SensorBase from "./SensorBase";

const FIELD = "airPressure";
const UNIT = "kPa";

const AirPressure: React.FC = () => {
  return (
    <SensorBase field={FIELD} unit={UNIT}></SensorBase>
  );
};

export default AirPressure;
